export const combineKindSubKind = ( timeslot ) => {
	if( timeslot === null || typeof timeslot === 'undefined' ) {
		return '';
	}

	return `${ timeslot.kind }_${ timeslot.sub_kind }`;
};
